import React from 'react';
import PropTypes from 'prop-types';

function ShowMorePager({ next = () => {} }) {
  return (
    <div className="row custom-pager">
      <div className="col-xs-12 right">
        <span className="show-more" onClick={next}>
          Show more
        </span>
      </div>
    </div>
  );
}

ShowMorePager.propTypes = {
  next: PropTypes.func,
};

export { ShowMorePager };
